import { type IExpenseRepository } from '@webapp/modules/expense/business-logic/interfaces/IExpenseRepository'
import { ExpenseUseCaseErrors } from '../ExpenseUseCaseErrors'

export class DuplicateExpenseUseCase {
  constructor(
    private readonly deps: {
      expenseRepository: IExpenseRepository
    }
  ) {}

  execute = async ({
    id,
    confirmOverwriteDraft = false,
  }: {
    id: number
    confirmOverwriteDraft?: boolean
  }) => {
    if (!confirmOverwriteDraft) {
      let drafts = []

      try {
        drafts = await this.deps.expenseRepository.getDrafts()
      } catch (e) {
        throw new ExpenseUseCaseErrors({
          name: 'FETCH_DRAFTS_FAILED',
          message: 'Failed to fetch drafts',
        })
      }

      if (drafts.length > 0) {
        throw new ExpenseUseCaseErrors({
          name: 'DUPLICATE_REQUIRE_CONFIRMATION_TO_OVERWRITE_DRAFT',
          message:
            'Execute use case again with [confirmOverwriteDraft=true] to confirm overwriting draft',
        })
      }
    }

    await this.deps.expenseRepository.duplicate(id)
  }
}
